import { render, staticRenderFns } from "./ProductsCategories.vue?vue&type=template&id=3c32c727&scoped=true&"
import script from "./ProductsCategories.vue?vue&type=script&lang=js&"
export * from "./ProductsCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCategories.vue?vue&type=style&index=0&id=3c32c727&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32c727",
  null
  
)

export default component.exports